import { getNumber } from './number';

export const formatPriceValue: any = (price, currency) =>
  new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    ...(currency ? { style: 'currency', currency } : {}),
  }).format(price);

const toNumber = (value: unknown) =>
  value === '' || value == null ? undefined : getNumber(Number(value));

export const calculateTotalPrice = (unitPrice: unknown, numberOfUnits: unknown) => {
  const price = toNumber(unitPrice);
  const units = toNumber(numberOfUnits);

  return price === undefined || units === undefined
    ? undefined
    : (Math.round(price * 100) * units) / 100;
};
